import { toast } from "react-toastify";
import swal from "sweetalert";
export function pushNotification(msg, type, position, duration) {
  if (type === "info") {
    return toast.info(msg, {
      position: position ? toast.POSITION[position] : toast.POSITION.TOP_CENTER,
      autoClose: duration ? duration : 2000,
      pauseOnFocusLoss: true,
      pauseOnHover: false,
      newestOnTop: true,
    });
  } else if (type === "success") {
    return swal({
      title: msg,
      text: "",
      icon: "success",
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickOutside: false,
      button: false,
      timer: duration ? duration : 2000,
    });
  } else if (type === "warning") {
    return swal({
      title: msg,
      text: "",
      icon: "warrning",
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickOutside: false,
      button: false,
      timer: duration ? duration : 2000,
    });
  } else if (type === "error") {
    return swal({
      title: msg,
      text: "",
      icon: "error",
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickOutside: false,
      button: false,
      timer: duration ? duration : 2000,
    });
  } else {
    return toast.info(msg, {
      position: position ? toast.POSITION[position] : toast.POSITION.TOP_CENTER,
      autoClose: duration ? duration : 2000,
      pauseOnFocusLoss: true,
      pauseOnHover: false,
      newestOnTop: true,
    });
  }
}
